module.exports = __webpack_public_path__ + "img/asset_SOL.ac8fef85.svg";